import { useState } from "react";
import { useGetPracticeLocationsQuery } from "../../redux/service/appointments_service";
import { Loader } from "../../components/Loader";
import LocationPinIcon from "../../components/Icons/LocationPinIcon";
import SelectedTickIcon from "../../components/Icons/SelectedTickIcon";

const LocationList = ({ selectedLocation, setSelectedLocation }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data: locations, isLoading } = useGetPracticeLocationsQuery();

  const filteredLocations = locations?.filter((location) => {
    const name = location?.name?.toLowerCase() || "";
    const address = location?.address1?.toLowerCase() || "";
    const city = location?.city?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();
    return name.includes(search) || address.includes(search) || city.includes(search);
  });

  return (
    <div className="flex flex-col h-full bg-white">
      <div className="sticky top-0 z-10 p-4 border-b border-gray-200 bg-gray-50 flex-shrink-0">
        <div className="relative">
          <input
            type="text"
            placeholder="Search locations by name, address, or city..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <svg
            className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {filteredLocations?.map((location) => (
          <div
            key={location?.id}
            className={`cursor-pointer transition-all duration-200 border-b border-gray-200 last:border-b-0 ${
              selectedLocation?.id === location?.id
                ? "bg-blue-50 border-l-4 border-l-blue-500 shadow-sm"
                : "hover:bg-gray-50 border-l-4 border-l-transparent"
            }`}
            onClick={() => setSelectedLocation(location)}>
            <div className="flex justify-between items-center p-4">
              <div className="flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    selectedLocation?.id?.toString() === location?.id?.toString()
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 text-gray-400"
                  }`}>
                  <LocationPinIcon className="w-5 h-5" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">{location?.name}</p>
                  {location?.address1 && (
                    <p className="text-sm text-gray-600">
                      {location?.address1}
                      {location?.city && `, ${location?.city}`}
                      {location?.state && `, ${location?.state}`}
                      {location?.zip && ` ${location?.zip}`}
                    </p>
                  )}
                </div>
              </div>
              {selectedLocation?.id === location?.id && (
                <SelectedTickIcon className="w-6 h-6 text-blue-500" />
              )}
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="py-8"><Loader /></div>
        )}
        {filteredLocations?.length === 0 && !isLoading && (
          <div className="py-8 text-center text-gray-500">
            <p className="text-lg">
              {searchTerm ? "No locations found matching your search" : "No locations available"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationList;
